import React from "react";
import { TablePagination } from "@mui/material";

interface TablePaginationSectionProps {
    totalCount: number;
    page: number;
    rowsPerPage: number;
    onPageChange: (newPage: number) => void;
    onRowsPerPageChange: (newSize: number) => void;
}

const TablePaginationSection = ({
    totalCount,
    page,
    rowsPerPage,
    onPageChange,
    onRowsPerPageChange,
}: TablePaginationSectionProps) => {
    return (
        <TablePagination
            component="div"
            count={totalCount}
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={(_, newPage) => onPageChange(newPage)}
            onRowsPerPageChange={(e) =>
                onRowsPerPageChange(parseInt(e.target.value, 10))
            }
            rowsPerPageOptions={[5, 10, 25, 50]}
            labelRowsPerPage="Wierszy na stronę:"
        />
    );
};

export default TablePaginationSection;
